import '../Finca';

// export {default as SalesList} from './List'
export { default as FincaEdit } from './Edit'
